{
  "basicTerms": {
    "selectedOfTotal": "เลือกแล้ว {selected}/{total}",
    "search": "ค้นหา",
    "summary": "สรุป",
    "insights": "ข้อมูลเชิงลึก",
    "help": "ความช่วยเหลือ",
    "expand": "ขยาย",
    "collapse": "ย่อ",
    "menu": "เมนู",
    "account": "บัญชี",
    "logout": "ออกจากระบบ",
    "signIn": "เข้าสู่ระบบ",
    "days": "วัน | วัน",
    "phone": "โทรศัพท์",
    "subscribers": "ผู้รับการแจ้งเตือน | ผู้รับการแจ้งเตือน",
    "favorites": "รายการโปรด | รายการโปรด",
    "others": "อื่น ๆ | อื่น ๆ",
    "yes": "ใช่",
    "no": "ไม่ใช่",
    "locations": "สถานที่ | สถานที่",
    "active": "ใช้งานอยู่",
    "inactive": "ไม่ได้ใช้งาน",
    "all": "ทั้งหมด",
    "view": "ดู",
    "language": "ภาษา",
    "required": "จำเป็น",
    "timezone": "เขตเวลา",
    "new": "ใหม่",
    "open": "เปิด",
    "close": "ปิด",
    "closed": "ปิดแล้ว",
    "occupied": "มีผู้ใช้งาน",
    "reserved": "จองแล้ว",
    "enabled": "เปิดใช้งาน",
    "disabled": "ปิดใช้งาน",
    "enable": "เปิดใช้งาน",
    "disable": "ปิดใช้งาน",
    "print": "พิมพ์",
    "download": "ดาวน์โหลด",
    "zoomIn": "ซูมเข้า",
    "zoomOut": "ซูมออก",
    "previous": "ก่อนหน้า",
    "next": "ถัดไป",
    "version": "เวอร์ชัน",
    "setup": "ตั้งค่า",
    "caution": "ข้อควรระวัง",
    "notes": "หมายเหตุ | หมายเหตุ",
    "add": "เพิ่ม",
    "remove": "ลบ",
    "duration": "ระยะเวลา",
    "link": "เชื่อมโยง",
    "unlink": "ยกเลิกการเชื่อมโยง",
    "to": "ถึง",
    "success": "สำเร็จ",
    "error": "ข้อผิดพลาด",
    "info": "ข้อมูล",
    "warning": "คำเตือน",
    "time": "เวลา",
    "saved": "บันทึกแล้ว",
    "forms": "แบบฟอร์ม | แบบฟอร์ม",
    "is": "คือ",
    "only": "เท่านั้น",
    "saving": "กำลังบันทึก",
    "text": "ข้อความ",
    "zip": "zip",
    "spreadsheet": "สเปรดชีต",
    "image": "รูปภาพ",
    "cloning": "กำลังโคลน",
    "clone": "โคลน",
    "added": "เพิ่มแล้ว",
    "removed": "ลบแล้ว",
    "planned": "มีการวางแผน",
    "unplanned": "ไม่ได้วางแผน",
    "checkedIn": "เช็กอินแล้ว",
    "checkedOut": "เช็กเอาต์แล้ว",
    "more": "เพิ่มเติม",
    "okay": "ตกลง",
    "reschedule": "เลื่อนนัด",
    "results": "ผลลัพธ์ | ผลลัพธ์",
    "none": "ไม่มี",
    "pages": "หน้า | หน้า",
    "pageOfTotal": "หน้า {current} จาก {total}",
    "of": "จาก",
    "default": "ค่าเริ่มต้น",
    "soon": "เร็ว ๆ นี้",
    "grid": "ตาราง",
    "list": "รายการ",
    "booked": "จองแล้ว",
    "arrivals": "การมาถึง | การมาถึง",
    "early": "ก่อนเวลา",
    "late": "ล่าช้า",
    "onTime": "ตรงเวลา",
    "area": "พื้นที่ | พื้นที่",
    "spot": "ช่องจอด",
    "single": "รายการเดียว",
    "multiple": "หลายรายการ",
    "filter": "ตัวกรอง",
    "board": "บอร์ด",
    "at": "ที่",
    "from": "จาก",
    "recent": "ล่าสุด",
    "delivered": "ส่งถึงแล้ว",
    "sent": "ส่งแล้ว",
    "create": "สร้าง",
    "tasks": "งาน | งาน",
    "emails": "อีเมล | อีเมล",
    "passwords": "รหัสผ่าน | รหัสผ่าน",
    "limits": "ขีดจำกัด",
    "assignee": "ผู้รับผิดชอบ",
    "comment": "ความคิดเห็น",
    "issue": "ปัญหา",
    "urgent": "เร่งด่วน",
    "retry": "ลองใหม่",
    "custom": "กำหนดเอง",
    "na": "ไม่มีข้อมูล"
  },
  "phrases": {
    "copyToClipboard": "คัดลอกไปยังคลิปบอร์ด",
    "copiedToClipboard": "คัดลอกไปยังคลิปบอร์ดแล้ว",
    "warehouseAddress": "ที่อยู่คลังสินค้า",
    "cloneSchedule": "โคลนตารางเวลา",
    "open24Hours": "เปิด 24 ชั่วโมง",
    "featureEnabled": "เปิดใช้งานฟีเจอร์แล้ว",
    "featureDisabled": "ปิดใช้งานฟีเจอร์แล้ว",
    "learnMore": "เรียนรู้เพิ่มเติม",
    "minuteLabel": "{minutes} นาที",
    "minuteLabelFull": "{minutes} นาที",
    "thisActionCannotBeUndone": "การดำเนินการนี้ไม่สามารถยกเลิกได้",
    "areYouSure": "คุณแน่ใจหรือไม่",
    "unknownUser": "ผู้ใช้ที่ไม่รู้จัก",
    "leaveWithoutSaving": "ออกโดยไม่บันทึก",
    "learnHowItWorks": "เรียนรู้วิธีการทำงาน",
    "allFields": "ทุกช่องข้อมูล",
    "selectColumns": "เลือกคอลัมน์",
    "selectedColumns": "คอลัมน์ที่เลือก",
    "addFiles": "เพิ่มไฟล์ | เพิ่มไฟล์",
    "tasks": "ไม่มีงาน | {count} งาน | {count} งาน",
    "driversSelfCheckin": "การเช็กอินด้วยตนเองของคนขับ",
    "addReferenceNumber": "เพิ่มหมายเลขอ้างอิง",
    "myAccount": "บัญชีของฉัน"
  },
  "messages": {
    "theConfirmationFieldDoesNotSupportPasting": "ช่องยืนยันไม่รองรับการวาง",
    "youMayHaveUnsavedChangesAreYouSureYouWantToLeaveThisPage": "คุณอาจมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก คุณแน่ใจหรือไม่ว่าต้องการออกจากหน้านี้",
    "browserDoesNotSupportCopyFunction": "เบราว์เซอร์ไม่รองรับฟังก์ชันคัดลอก",
    "permissionToAccessClipboardWasDeniedToEnableAccessUpdateYourBrowserSettings": "สิทธิ์ในการเข้าถึงคลิปบอร์ดถูกปฏิเสธ หากต้องการเปิดการเข้าถึง โปรดอัปเดตการตั้งค่าเบราว์เซอร์ของคุณ",
    "alternativelyYouCanManuallyCopy": "หรือคุณสามารถคัดลอกด้วยตนเอง",
    "areYouSureYouWantToLeaveYouMayHaveUnsavedChanges": "คุณแน่ใจหรือไม่ว่าต้องการออก คุณอาจมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก",
    "noResultsFound": "ไม่พบผลลัพธ์",
    "maximumOfReferenceNumbersAllowedCountRemoved": "อนุญาตหมายเลขอ้างอิงสูงสุด {maxItems} รายการ ลบออกแล้ว {removedCount} รายการ"
  },
  "fileFormats": {
    "jpeg": "jpeg",
    "jpg": "jpg",
    "png": "png",
    "webp": "webp",
    "pdf": "pdf"
  },
  "specialtyTerms": {
    "opendock": "Opendock",
    "warehouses": "คลังสินค้า | คลังสินค้า",
    "carrierContacts": "ผู้ติดต่อของผู้ขนส่ง | ผู้ติดต่อของผู้ขนส่ง",
    "loadTypes": "ประเภทสินค้า | ประเภทสินค้า",
    "docks": "ท่าเทียบรถ | ท่าเทียบรถ",
    "appointments": "การนัดหมาย | การนัดหมาย",
    "users": "ผู้ใช้ | ผู้ใช้",
    "organizations": "องค์กร | องค์กร",
    "orgs": "องค์กร | องค์กร",
    "companies": "บริษัท | บริษัท",
    "referenceNumber": "หมายเลขอ้างอิง",
    "refNumber": "หมายเลขอ้างอิง",
    "status": "สถานะ",
    "orgLoadTypes": "ประเภทสินค้าขององค์กร",
    "schedulingPortal": "พอร์ทัลการนัดหมาย",
    "customFields": "ช่องข้อมูลที่กำหนดเอง | ช่องข้อมูลที่กำหนดเอง",
    "interval": "ช่วงเวลา",
    "drivers": "คนขับ | คนขับ",
    "carriers": "ผู้ขนส่ง | ผู้ขนส่ง",
    "tags": "แท็ก | แท็ก",
    "yardManagement": "การจัดการลานจอด",
    "carrier": "ผู้ขนส่ง | ผู้ขนส่ง",
    "assets": "อุปกรณ์ | อุปกรณ์",
    "tvMode": "โหมดทีวี",
    "gridView": "มุมมองตาราง",
    "listView": "มุมมองรายการ",
    "gateManagement": "การจัดการประตูทางเข้า",
    "selfCheckIn": "การเช็กอินด้วยตนเอง",
    "gateFeed": "ฟีดประตูทางเข้า"
  },
  "appointmentStatuses": {
    "NoShow": "ไม่มาตามนัด",
    "Cancelled": "ยกเลิกแล้ว",
    "Requested": "ส่งคำขอแล้ว",
    "Scheduled": "นัดหมายแล้ว",
    "Arrived": "มาถึงแล้ว",
    "InProgress": "กำลังดำเนินการ",
    "Completed": "เสร็จสิ้น",
    "Reserves": "การจองล่วงหน้า"
  },
  "appointmentTypes": {
    "standard": "มาตรฐาน",
    "reserved": "จองล่วงหน้าแล้ว",
    "reserve": "จองล่วงหน้า"
  },
  "appointmentCreatorTypes": {
    "warehouseUser": "ผู้ใช้คลังสินค้า",
    "carrier": "ผู้ขนส่ง"
  },
  "roles": {
    "base": "พื้นฐาน",
    "carrier": "ผู้ขนส่ง",
    "carrierAdmin": "ผู้ดูแลระบบของผู้ขนส่ง",
    "spectator": "ผู้ชม",
    "attendant": "พนักงานประจำ",
    "operator": "ผู้ปฏิบัติงาน",
    "admin": "ผู้ดูแลระบบ",
    "owner": "เจ้าของ",
    "internal": "ภายใน",
    "god": "ผู้ดูแลสูงสุด"
  },
  "weekdays": {
    "sunday": "วันอาทิตย์",
    "monday": "วันจันทร์",
    "tuesday": "วันอังคาร",
    "wednesday": "วันพุธ",
    "thursday": "วันพฤหัสบดี",
    "friday": "วันศุกร์",
    "saturday": "วันเสาร์"
  },
  "weekdaysAbbr": {
    "sun": "อา.",
    "mon": "จ.",
    "tue": "อ.",
    "wed": "พ.",
    "thu": "พฤ.",
    "fri": "ศ.",
    "sat": "ส."
  },
  "buttons": {
    "nevermind": "ไม่เป็นไร",
    "select": "เลือก",
    "confirm": "ยืนยัน",
    "next": "ถัดไป",
    "previous": "ก่อนหน้า",
    "create": "สร้าง",
    "edit": "แก้ไข",
    "save": "บันทึก",
    "send": "ส่ง",
    "yesDelete": "ใช่ ลบ",
    "skipCreation": "ข้ามการสร้าง",
    "cancel": "ยกเลิก",
    "export": "ส่งออก",
    "saveChanges": "บันทึกการเปลี่ยนแปลง",
    "exportData": "ส่งออกข้อมูล",
    "resetToDefault": "รีเซ็ตเป็นค่าเริ่มต้น"
  },
  "tooltips": {
    "notAvailable": "ไม่พร้อมใช้งาน",
    "notAvailableForUserRole": "ไม่พร้อมใช้งานสำหรับบทบาทผู้ใช้ของคุณ"
  },
  "errors": {
    "unkownError": "เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ",
    "thisFieldIsRequired": "ช่องนี้จำเป็นต้องกรอก",
    "passwordDoesNotMeetRequirements": "รหัสผ่านไม่เป็นไปตามข้อกำหนด",
    "emailMustBeValid": "อีเมลต้องถูกต้อง",
    "pleaseEnterAValidPhoneNumber": "โปรดกรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
    "pleaseEnterAValidUrl": "โปรดกรอก URL ที่ถูกต้อง",
    "invalidHour": "ชั่วโมงไม่ถูกต้อง",
    "invalidMinute": "นาทีไม่ถูกต้อง",
    "pleaseSelectAmOrPm": "เลือก AM หรือ PM",
    "pleaseEnterACompleteDateAndTime": "กรอกวันที่และเวลาให้ครบถ้วน",
    "mustBeANumber": "ต้องเป็นตัวเลข",
    "mustBeAPositiveInteger": "ต้องเป็นจำนวนเต็มบวก",
    "mustBeAWholeNumber": "ต้องเป็นจำนวนเต็ม",
    "isNotAValidNumber": "ไม่ใช่ตัวเลขที่ถูกต้อง",
    "invalidUuid": "uuid ไม่ถูกต้อง",
    "dateMustNotBeInThePast": "วันที่ต้องไม่เป็นวันที่ที่ผ่านมาแล้ว",
    "mustBeWithin24HoursOfStartTime": "ต้องอยู่ภายใน 24 ชั่วโมงจากเวลาเริ่มต้น",
    "pleaseSelectAtLeast": "โปรดเลือก{itemName}อย่างน้อย {requiredCount} รายการ | โปรดเลือก{itemName}อย่างน้อย {requiredCount} รายการ",
    "cannotSelectMoreThan": "ไม่สามารถเลือก{itemName}เกิน {limit} รายการ | ไม่สามารถเลือก{itemName}เกิน {limit} รายการ",
    "fieldMustEqual": "ช่องนี้ต้องเท่ากับ {value}",
    "mustBeXCharacters": "ต้องมี {length} อักขระ | ต้องมี {length} อักขระ",
    "mustBeAtLeastXCharacters": "ต้องมีความยาวอย่างน้อย {min} อักขระ | ต้องมีความยาวอย่างน้อย {min} อักขระ",
    "mustBeAtMostXCharacters": "ต้องมีความยาวไม่เกิน {max} อักขระ | ต้องมีความยาวไม่เกิน {max} อักขระ",
    "mustBeBetweenXAndYCharactersLong": "ต้องมีความยาวระหว่าง {min} ถึง {max} อักขระ",
    "mustBeNumberBetweenXAndY": "ต้องเป็นตัวเลขระหว่าง {min} ถึง {max}",
    "mustBeNumberGreaterThan": "ต้องเป็นตัวเลขที่มากกว่าหรือเท่ากับ {min}",
    "mustBeNumberLessThan": "ต้องเป็นตัวเลขที่น้อยกว่า {max}",
    "mustHaveAtLeast8Characters": "ต้องมีอย่างน้อย 8 อักขระ",
    "mustContainUpperCaseAndLowerCase": "ต้องมีทั้งตัวพิมพ์ใหญ่และตัวพิมพ์เล็ก",
    "mustContainAtLeastOneLetter": "ต้องมีตัวอักษรอย่างน้อยหนึ่งตัว",
    "mustContainAtLeastOneSpecialCharacter": "ต้องมีอักขระพิเศษอย่างน้อยหนึ่งตัว",
    "mustContainAtLeastOneNumber": "ต้องมีตัวเลขอย่างน้อยหนึ่งตัว",
    "atLeastOneReferenceNumberIsRequired": "ต้องระบุ{refNumberDisplayName}อย่างน้อยหนึ่งรายการ",
    "mustBeAValidNumber": "ต้องเป็นตัวเลขที่ถูกต้อง"
  },
  "warehouseAmenities": {
    "lumperServices": "บริการแรงงานขนถ่ายสินค้า (Lumper)",
    "overnightParking": "ที่จอดรถค้างคืน",
    "driversRestroom": "ห้องน้ำสำหรับคนขับ",
    "freeWiFi": "Wi-Fi ฟรี"
  },
  "warehousePPERequirements": {
    "safetyBoots": "รองเท้านิรภัย",
    "safetyGlasses": "แว่นตานิรภัย",
    "gloves": "ถุงมือ",
    "hardHat": "หมวกนิรภัย",
    "faceMask": "หน้ากากอนามัย",
    "noSmoking": "ห้ามสูบบุหรี่",
    "longPants": "กางเกงขายาว",
    "longSleeves": "เสื้อแขนยาว",
    "highVisibilityVest": "เสื้อกั๊กสะท้อนแสง",
    "hairAndBeardNet": "ตาข่ายคลุมผมและหนวดเครา"
  },
  "auditLog": {
    "header": "บันทึกการตรวจสอบ",
    "viewAuditLog": "ดูบันทึกการตรวจสอบ",
    "noAuditLogEvents": "ไม่มีเหตุการณ์ในบันทึกการตรวจสอบ",
    "timelineForAllUpdatesMadeToThis": "ไทม์ไลน์ของการอัปเดตทั้งหมดที่ทำกับรายการนี้",
    "hasTheWords": "มีคำว่า",
    "eventsFromDate": "เหตุการณ์ตั้งแต่วันที่",
    "searchEvents": "ค้นหาเหตุการณ์",
    "by": "โดย",
    "appointmentUpdatesTimeline": "ไทม์ไลน์การอัปเดตการนัดหมาย:",
    "moreUpdates": "อีก {count} การอัปเดต",
    "emailSubscribersUpdated": "อัปเดตผู้รับอีเมลแจ้งเตือนแล้ว",
    "detailsUpdated": "อัปเดตรายละเอียดแล้ว",
    "recurrenceCreated": "สร้างการนัดหมายซ้ำแล้ว",
    "recurrenceDeleted": "ลบการนัดหมายซ้ำแล้ว",
    "rescheduled": "เลื่อน{label}แล้ว",
    "etaUpdated": "อัปเดต ETA แล้ว",
    "emailNotifications": "การแจ้งเตือนทางอีเมล",
    "carrierContactUpdated": "อัปเดตผู้ติดต่อของผู้ขนส่งแล้ว",
    "reserveTransferred": "โอนการจองล่วงหน้าแล้ว",
    "tagsUpdated": "อัปเดตแท็กแล้ว",
    "scheduled": "กำหนด{label}แล้ว",
    "statusUpdated": "อัปเดตสถานะแล้ว",
    "timeUpdated": "อัปเดตเวลา{arrived}แล้ว",
    "dwellTimeUpdated": "อัปเดตระยะเวลาที่อยู่ในสถานที่แล้ว",
    "everyXAtXUntilX": "ทุก {weekDays} {'@'} {endTime} จนถึง {endDate}",
    "opendockTeam": "ทีม Opendock",
    "unknownUser": "ผู้ใช้ที่ไม่รู้จัก",
    "deleted": "ลบแล้ว",
    "hasBeenCleared": "ถูกล้างแล้ว",
    "actionUpdated": "อัปเดตแล้ว",
    "actionCreated": "สร้างแล้ว",
    "actionDeleted": "ลบแล้ว",
    "noAction": "ไม่มีการดำเนินการ",
    "emptyValue": "ค่าว่าง"
  },
  "timeline": {
    "createdTheTask": "สร้างงาน",
    "startedTheTask": "เริ่มงาน",
    "blockedTheTask": "บล็อกงาน",
    "unblockedTheTask": "ยกเลิกการบล็อกงาน",
    "completedTheTask": "ทำงานเสร็จสิ้น",
    "cancelledTheTask": "ยกเลิกงาน",
    "cancelledTheReserve": "ยกเลิกการจองล่วงหน้า",
    "cancelledTheReservationForSpot": "ยกเลิกการจอง {areaName} - {spotCode} สำหรับงานนี้",
    "reservedSpotForThisTask": "จอง {areaName} - {spotCode} สำหรับงานนี้",
    "reservedTheSpot": "จองช่องจอด",
    "reason": "เหตุผล: {reason}",
    "addedA": "เพิ่ม",
    "reportedAn": "รายงาน",
    "clearedThe": "ล้าง",
    "flaggedTheTask": "ปักธงงาน",
    "flaggedTheTaskAs": "ปักธงงานเป็น",
    "unflaggedTheTask": "ยกเลิกการปักธงงาน",
    "unflaggedTheTaskAs": "ยกเลิกการปักธงงานที่เป็น",
    "updatedTheTask": "อัปเดตงาน",
    "removedTask": "ลบงาน",
    "attachments": "ไฟล์แนบ",
    "confirmedTheLocation": "ยืนยันตำแหน่ง",
    "reportedAsMissing": "รายงานว่าสูญหาย",
    "noActivityYet": "ยังไม่มีกิจกรรม",
    "noAssignee": "ไม่มีผู้รับผิดชอบ",
    "failedToFetchYardTaskTimeline": "ดึงข้อมูลไทม์ไลน์งานในลานจอดไม่สำเร็จ",
    "failedToCreateComment": "สร้างความคิดเห็นไม่สำเร็จ"
  },
  "yardSpotStatusDialog": {
    "headers": {
      "actionThisSpot": "{action}ช่องจอดนี้หรือไม่"
    },
    "dropDownItems": {
      "cleaning": "กำลังทำความสะอาด",
      "underMaintenance": "อยู่ระหว่างการซ่อมบำรุง",
      "blockedByEquipment": "ถูกกีดขวางโดยอุปกรณ์",
      "safetyInspection": "ตรวจสอบความปลอดภัย",
      "routineInspection": "ตรวจสอบตามรอบ",
      "reserved": "จองแล้ว",
      "repairsNeeded": "ต้องซ่อมแซม",
      "damage": "ชำรุดเสียหาย"
    },
    "labels": {
      "reason": "เหตุผล",
      "additionalNotes": "หมายเหตุเพิ่มเติม"
    },
    "placeholders": {
      "selectAReason": "เลือกเหตุผล",
      "enterAdditionalNotes": "กรอกหมายเหตุเพิ่มเติม"
    },
    "messages": {
      "thisSpotWillRemainUnavailable": "ช่องจอดนี้จะไม่พร้อมสำหรับการมอบหมายอุปกรณ์จนกว่าจะตั้งค่าเป็นเปิดอีกครั้ง",
      "thisDoorWillBeSetAsOpen": "ประตูนี้จะถูกตั้งค่าเป็นเปิด และจะพร้อมสำหรับการมอบหมายอุปกรณ์อีกครั้ง",
      "assetInTransitClosingWillBlockMove": "อุปกรณ์ {assetCode} กำลังเคลื่อนย้ายมายังช่องจอดนี้ การปิดช่องจอดจะทำให้การเคลื่อนย้ายไม่สามารถเสร็จสิ้นได้"
    }
  },
  "tasks": {
    "presenter": {
      "unassigned": "ยังไม่ได้มอบหมาย",
      "noDueDate": "ไม่มีวันครบกำหนด",
      "fromAnySpot": "จากช่องจอดใดก็ได้",
      "toAnySpot": "ไปยังช่องจอดใดก็ได้",
      "anyAsset": "อุปกรณ์ใดก็ได้",
      "types": {
        "move": "เคลื่อนย้าย"
      },
      "status": {
        "toDo": "สิ่งที่ต้องทำ",
        "inProgress": "กำลังดำเนินการ",
        "completed": "เสร็จสิ้น",
        "canceled": "ยกเลิกแล้ว"
      },
      "issue": "ปัญหา",
      "relatedEntity": {
        "spotArea": "พื้นที่",
        "spot": "ช่องจอด",
        "asset": "อุปกรณ์"
      }
    }
  },
  "readyForPickupNotificationDialog": {
    "title": "การแจ้งเตือนพร้อมรับสินค้า",
    "messages": {
      "body": "ส่งอีเมลถึงผู้ติดต่อต่อไปนี้เพื่อแจ้งว่าอุปกรณ์ {assetContainerCode} พร้อมให้รับที่ {warehouseName}",
      "notificationSent": "ส่งการแจ้งเตือนสำเร็จแล้ว",
      "notificationFailed": "ส่งการแจ้งเตือนไม่สำเร็จ โปรดลองอีกครั้ง"
    },
    "labels": {
      "notifyTheseContacts": "แจ้งผู้ติดต่อเหล่านี้:",
      "suggestedContacts": "ผู้ติดต่อที่แนะนำ:"
    },
    "buttons": {
      "skipNotification": "ข้ามการแจ้งเตือน"
    }
  }
}
